import type { BillingDepleted } from "@orbin/contracts";

type PausableRun = {
  id?: string;
  status: string;
  createdAt?: string;
  pausedForBudget?: BillingDepleted | null | undefined;
};

/**
 * The credit state a thread is waiting on, from its persisted runs. A run paused for budget is not
 * working and cannot be stopped; the chat shows why and how to continue, and the run resumes
 * by itself once the workspace has credit. Null when no run is paused.
 *
 * A pause is behind the person once a later run (`newest`, the thread's latest) is not paused
 * itself: they sent again and it went through, so the old pause no longer describes the chat.
 */
export function budgetPauseOf(
  runs: readonly PausableRun[],
  newest?: PausableRun | null,
): BillingDepleted | null {
  for (const run of runs) {
    if (run.status !== "paused_for_budget" || !run.pausedForBudget) continue;
    const superseded =
      newest &&
      newest.status !== "paused_for_budget" &&
      newest.id !== run.id &&
      newest.createdAt !== undefined &&
      run.createdAt !== undefined &&
      newest.createdAt > run.createdAt;
    if (!superseded) return run.pausedForBudget;
  }
  return null;
}
